import { DEALER_ROLE_IDS } from '../../enums/UserRoleId.enum';

/**
 * The Bug Reporter is for LHPH staff only. Kevin asked for dealers' "User Settings" to go,
 * keeping only password change and 2FA (lhphcapital-42bw; Blake decided 2026-10-23).
 *
 * Both the profile toggle and the floating button read this, so a dealer who switched the
 * reporter on before this change loses the button too, not just the toggle. role_id arrives
 * as a number or a numeric string, so it is converted before the lookup.
 */
export const canUseBugReporter = (user?: { role_id?: number | string | null } | null): boolean =>
  !!user && user.role_id != null && !DEALER_ROLE_IDS.has(Number(user.role_id));
